import classNames from 'classnames';
import { includes } from 'lodash';
import React from 'react';
import KnowledgeCheckNew from 'components/Questions/KnowledgeCheck/KnowledgeCheckNew';
import KnowledgeCheckSorting from 'components/Questions/KnowledgeCheckSorting/KnowledgeCheckSorting';
import KnowledgeCheckMatching from 'components/Questions/KnowledgeCheckMatching/KnowledgeCheckMatching';
import QuestionWithMetadata from 'components/Practice/QuestionWithMetadata';
import NewMessage from 'components/ChatPractice/NewMessage';
import QuestionFieldContainer from 'components/TicketHandlingPractice/QuestionFieldContainer';
import SelectOption from '../selectOption';
import ElementPrompt from './ElementPrompt';
import QuestionHint from './QuestionHint';

const NonTabbedElements = ({
  content,
  applyChanges,
  handleUpdate,
  requestUpdateAndApplyChanges,
}) => {
  const { question_type: questionType, choices, id, valid } = content;
  const isSelectOption = includes(
    'multiple_choice multiple_select survey',
    questionType,
  );

  const isMatchingElement = questionType === 'matching';
  const isKnowledgeCheckElement = questionType === 'knowledge_check';
  const isSortingElement = questionType === 'sorting';
  const isInteractiveElement = includes('sorting matching', questionType);
  const isZendesk = content.zendesk;
  const questionHasMetadata = includes(
    'email_reply ticket_handling',
    questionType,
  );
  const bodyStyles = classNames('EditorElement-body ', {
    ChoiceElement: isKnowledgeCheckElement,
    InteractiveElement: isInteractiveElement,
    MatchingElement: isMatchingElement,
  });
  return (
    <>
      <ElementPrompt
        applyChanges={applyChanges}
        handleUpdate={handleUpdate}
        content={content}
        hasChoices={isSelectOption}
        isInteractiveElement={isInteractiveElement}
      />
      <div className={bodyStyles}>
        {questionHasMetadata && (
          <QuestionWithMetadata
            questionType={questionType}
            applyChanges={applyChanges}
            handleUpdate={handleUpdate}
            questionData={
              content.raw_choices ? JSON.parse(content.raw_choices) : {}
            }
            isZendesk={isZendesk}
            zendeskSupportLogo={content.zendesk_support_logo}
          />
        )}
        {questionType === 'chat' && (
          <NewMessage
            applyChanges={applyChanges}
            handleUpdate={handleUpdate}
            messageData={
              content.raw_choices ? JSON.parse(content.raw_choices) : ''
            }
          />
        )}
        {questionType === 'ticket_handling' && !isZendesk && (
          <QuestionFieldContainer
            questionId={content.id}
            questionFields={content.fields}
          />
        )}
        {isKnowledgeCheckElement && (
          <KnowledgeCheckNew
            choices={choices}
            questionId={id}
            applyChanges={applyChanges}
            handleUpdate={handleUpdate}
          />
        )}
        {isSortingElement && (
          <KnowledgeCheckSorting
            requestUpdateAndApplyChanges={requestUpdateAndApplyChanges}
            choices={choices}
            questionId={id}
            applyChanges={applyChanges}
            handleUpdate={handleUpdate}
          />
        )}
        {isMatchingElement && (
          <KnowledgeCheckMatching
            requestUpdateAndApplyChanges={requestUpdateAndApplyChanges}
            choices={choices}
            questionId={id}
            applyChanges={applyChanges}
            handleUpdate={handleUpdate}
          />
        )}
      </div>
      {isSelectOption && (
        <SelectOption
          content={content}
          applyChanges={applyChanges}
          handleUpdate={handleUpdate}
          questionType={questionType}
        />
      )}
      <div
        className={classNames({
          'EditorElement-footer pl-32 pr-32 border-top-0':
            !isSortingElement && !isSelectOption && !isMatchingElement,
          'InteractiveElement--footer': isSortingElement,
        })}
      >
        {isKnowledgeCheckElement && (
          <QuestionHint
            questionType={questionType}
            isValid={valid}
            hasWarning={isKnowledgeCheckElement}
          />
        )}
      </div>
    </>
  );
};

export default NonTabbedElements;
